module.exports = __webpack_public_path__ + "img/7.56842e56.gif";